import { createElement } from 'react';
import {
  ApiBlueprint,
  createFrontendPlugin,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import {
  stackStorageLifecycleTenant,
  stackSupports,
} from '@internal/plugin-stack-common';
import { StorageLifecycleClient, storageLifecycleApiRef } from './api';

const storageLifecycleApi = ApiBlueprint.make({
  name: 'storage-lifecycle',
  params: defineApi =>
    defineApi({
      api: storageLifecycleApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new StorageLifecycleClient(discoveryApi, fetchApi),
    }),
});

const storageLifecycleTab = EntityContentBlueprint.make({
  name: 'storage-lifecycle',
  params: {
    path: '/storage-lifecycle',
    title: 'Storage Lifecycle',
    // Only where there is a bucket to hold a policy. Retention on a VM is not
    // a thing this tab could set even if it were shown.
    filter: entity =>
      stackSupports(entity, 'storage-lifecycle') &&
      Boolean(stackStorageLifecycleTenant(entity)),
    loader: () =>
      import('./components/StorageLifecycleContent').then(m =>
        createElement(m.StorageLifecycleContent),
      ),
  },
});

export const storageLifecyclePlugin = createFrontendPlugin({
  pluginId: 'storage-lifecycle',
  extensions: [storageLifecycleApi, storageLifecycleTab],
});
